export const opacityToHex = (opacity: number) => {
	const scaledAlpha = opacity * 255;
	const roundedAlpha = Math.round(scaledAlpha);

	let hexAlpha = roundedAlpha.toString(16);

	if (hexAlpha.length === 1) {
		hexAlpha = '0' + hexAlpha;
	}

	return hexAlpha.toUpperCase();
};
